import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh', // 设置默认语言
  fallbackLocale: 'zh', // 设置备用语言
  messages: {
    zh,
    en
  }
})

export default i18n
